import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-minus-icon',
	templateUrl: './minus-icon.component.html',
})
export class MinusIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
